var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-warning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TAC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D_TAC_Error_mobile@2x",
    transform: "translate(-946.000000, -555.000000)",
    fill: "#FF0000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(601.000000, 415.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-warning",
    transform: "translate(345.000000, 140.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,0 C4.02943725,0 0,4.02943725 0,9 C0,13.9705627 4.02943725,18 9,18 C13.9705627,18 18,13.9705627 18,9 C18,4.02943725 13.9705627,0 9,0 M9,1.81 C12.964,1.81 16.19,5.036 16.19,9 C16.19,12.964 12.964,16.19 9,16.19 C5.036,16.19 1.81,12.964 1.81,9 C1.81,5.036 5.036,1.81 9,1.81",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.15,4.433 L9.764,10.862 C9.73457602,11.3094155 9.34847261,11.6485422 8.901,11.62 C8.49024654,11.5980762 8.16077033,11.2724661 8.134,10.862 L7.749,4.433 C7.7318384,4.11638436 7.84131935,3.80594501 8.05330018,3.57013978 C8.26528102,3.33433455 8.56235082,3.19253117 8.879,3.176 C9.21961145,3.15472408 9.55310891,3.27984832 9.79566522,3.51992177 C10.0382215,3.75999523 10.1667704,4.09218767 10.149,4.433 M9.85,13.367 C9.85,13.859 9.446,14.2570141 8.95,14.2570141 C8.71263013,14.2583298 8.48445444,14.1653084 8.3156709,13.9984002 C8.14688735,13.831492 8.05132238,13.6043699 8.05,13.367 C8.05,12.876 8.452,12.477 8.95,12.477 C9.446,12.477 9.85,12.876 9.85,13.367",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsError);
export default __webpack_public_path__ + "static/media/icons-error.804fccfa2aee1f5406684a20f048ffa6.svg";
export { ForwardRef as ReactComponent };